import { getService } from './service';

function bufferToBlob(buffer, mime) {
  return new Blob([buffer], { type: mime });
}

// Types: Event, Person, Warrants, Address, FIREARM, ITEM, JEWELRY, STRUCTURE, SUBSTANCE, 
// EVIDENCE, INCIDENTPERSON, INCIDENTPROPERTY, VEHICLE, 
export const uploadAttachment = (id, file, type = 'Event', descr = '', codeAttachmentType) => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.readAsDataURL(file);
    try {
      reader.onload = async function () {
        try {
          const service = getService('cad-attachments');
          const result = await service.create({
            parentType: type,
            ptsParentID: id,
            fileName: file.name,
            fileType: file.name.split('.')[1],
            data: reader.result.split(',')[1],
            description: descr,
            codeAttachmentType: codeAttachmentType,
          });
          resolve(result);
        } catch(err) {
          reject(err);
        }
      };
    } catch (err) {
      reject(err);
    }
  });
};


export const uploadAttachments = async (attachments = []) => {
  if (!attachments || attachments.length === 0) return [];

  const response = await Promise.all(
    attachments.map((att) =>
      uploadFormDataAttachments(
        att.parentId,
        att.file,
        att.fileName,
        att.parentType,
        att.descr || '',
        att.user,
        att.codeAttachmentType,
        att.clearanceLevel ?? 0
      )
    )
  );

  return response;
};
export const uploadFormDataAttachments = async (
  parentId,
  file,
  fileName,
  parentType,
  descr = '',
  user,
  codeAttachmentType,
  clearanceLevel
) => {
  return new Promise(async (resolve, reject) => {
    const formData = new FormData();
    formData.append('ptsParentID', parentId);
    formData.append('file', file);
    formData.append('fileName', fileName);
    formData.append('fileType', fileName.split('.').pop());
    formData.append('parentType', parentType);
    formData.append('description', descr);
    formData.append('CreatedBy', user);
    formData.append('UpdatedBy', user);
    formData.append('codeAttachmentType', codeAttachmentType);
    formData.append('clearanceLevel', clearanceLevel);
    const service = getRestService('rms-attachments');
    try {
      const response = await service.create(formData);
      resolve(response);
    } catch (err) {
      reject(err);
    }
  });
};

export const uploadRMSAttachment = (
  id,
  file,
  type,
  descr = '',
  user,
  codeAttachmentType,
  clearanceLevel
) => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.readAsDataURL(file);
    try {
      reader.onload = async function () {
        try {
          const service = getService('rms-attachments');
          const result = await service.create({
            parentType: type,
            ptsParentID: id,
            fileName: file.name,
            fileType: file.name.split('.')[1],
            data: reader.result.split(',')[1],
            mimeType: file.type,
            description: descr,
            codeAttachmentType,
            clearanceLevel,
            CreatedBy: user,
            UpdatedBy: user,
          });
          resolve(result);
        } catch (err) {
          reject(err);
        }
      };
    } catch (err) {
      reject(err);
    }
  });
};


export const uploadPersonPhoto = (data) => {
  const { file, ptsPersonID, ImageTypeCode, IsMark, Location, Gang,
    Description, MarkType } = data;
  const { name } = file;
  const fileName = name ? file.name.substring(0, 49) : 'Snapshot';
  const fileType = name ? file.name.split('.')[1] : 'png';
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.readAsDataURL(file);
    try {
      reader.onload = async function () {
        const service = getService('cad-upload-person-photo');
        const result = await service.create({
          ptsPersonID,
          ImageTypeCode,
          IsMark,
          Location,
          Gang,
          MarkType,
          Description,
          fileName,
          fileType,
          data: reader.result.split(',')[1],
        });
        resolve(result);
      };
    } catch (err) {
      reject(err);
    }
  });
};

export const downloadPersonPhoto = (id, name) => {
  return new Promise((resolve, reject) => {
    const service = getService('cad-upload-person-photo');
    service
      .get(id)
      .then((res) => {
        const blob = bufferToBlob(res.buffer, res.type);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = name;
        link.click();
        return resolve();
      })
      .catch(reject);
  });
};

export const downloadAttachment = (id, name) => {
  return new Promise((resolve, reject) => {
    const service = getService('cad-attachments');
    service
      .get(id)
      .then((res) => {
        const blob = bufferToBlob(res.buffer, res.type);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = name;
        link.click();
        return resolve();
      })
      .catch(reject);
  });
};

export const removeAttachment = (id) => {
  const service = getService('cad-attachments');
  return service.remove(id);
};

export const findAttachments = (type, id) => {
  const service = getService('cad-attachments');
  return service.find({ query: { ParentType: type, ptsParentID: id } });
};

export const updateAttachment = (data) => {
  const service = getService('cad-attachments');
  return service.patch(data.ptsAttachmentID, data);
}